import type { Track } from '../types';
import type { Words } from '../copy';
import { fmtDur } from '../format';

interface Props {
  tracks: Track[];
  w: Words;
  canAddTake: boolean;
  canAddLoop: boolean;
  playingAll: boolean;
  playingTrack: string | null;
  onAddTake: () => void;
  onAddLoop: () => void;
  onPlayAll: () => void;
  onStop: () => void;
  onPlay: (t: Track) => void;
  onVolume: (id: string, v: number) => void;
  onMute: (id: string, muted: boolean) => void;
  onRemove: (id: string) => void;
  onExportMix: () => void;
}

export default function Tracks(p: Props) {
  const audible = p.tracks.filter((t) => !t.muted).length;

  return (
    <div className="tracks">
      <div className="tracks-head">
        <div className="label">{p.w.tracks}</div>
        <div className="row">
          <button className="btn violet sm" onClick={p.onAddTake} disabled={!p.canAddTake}>
            {p.w.addTake}
          </button>
          <button className="btn violet sm" onClick={p.onAddLoop} disabled={!p.canAddLoop}>
            {p.w.addLoop}
          </button>
        </div>
      </div>

      {p.tracks.length === 0 && <div className="note">{p.w.tracksEmpty}</div>}

      {p.tracks.map((t) => {
        const on = t.id === p.playingTrack;
        return (
          <div key={t.id} className={`trk${on ? ' playing' : ''}`}>
            <button
              className="btn xs"
              onClick={() => p.onPlay(t)}
              style={on ? { color: 'var(--green)', borderColor: 'var(--green)' } : undefined}
              aria-label={`Écouter ${t.name}`}
            >
              ▶
            </button>
            <span className="nm">{t.name}</span>
            <div className="vol">
              <input
                type="range"
                min={0}
                max={100}
                value={Math.round(t.volume * 100)}
                onChange={(e) => p.onVolume(t.id, Number(e.target.value) / 100)}
                aria-label={`Volume ${t.name}`}
                disabled={t.muted}
              />
            </div>
            <span className="dur">{fmtDur(t.buffer.duration)}</span>
            <label className="chk">
              <input
                type="checkbox"
                checked={t.muted}
                onChange={(e) => p.onMute(t.id, e.target.checked)}
              />
              {p.w.mute}
            </label>
            <button
              className="btn xs ghost"
              onClick={() => p.onRemove(t.id)}
              aria-label={`Supprimer ${t.name}`}
            >
              ✕
            </button>
          </div>
        );
      })}

      {p.tracks.length > 0 && (
        <div className="tracks-foot">
          <button
            className="btn green sm"
            onClick={p.playingAll ? p.onStop : p.onPlayAll}
            disabled={audible === 0}
          >
            {p.playingAll ? '■ Stop' : p.w.mixAll}
          </button>
          <div className="grow" />
          <button className="btn sm" onClick={p.onExportMix} disabled={audible === 0}>
            ⬇ {p.w.exportMix}
          </button>
        </div>
      )}
    </div>
  );
}
